import type { User } from '@supabase/supabase-js';

export type AccountIdentityStatus = {
  hasEmailPassword: boolean;
  hasGoogle: boolean;
  providers: string[];
};

export const getAccountIdentityStatus = (user: Pick<User, 'identities'>): AccountIdentityStatus => {
  const providers = [...new Set((user.identities ?? []).map((identity) => identity.provider).filter(Boolean))];
  return {
    hasEmailPassword: providers.includes('email'),
    hasGoogle: providers.includes('google'),
    providers,
  };
};

export const validatePasswordChange = ({
  hasEmailPassword,
  currentPassword,
  newPassword,
  confirmPassword,
}: {
  hasEmailPassword: boolean;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  if (hasEmailPassword && !currentPassword) return 'กรุณากรอกรหัสผ่านปัจจุบัน';
  if (newPassword.length < 8) return 'รหัสผ่านใหม่ต้องมีอย่างน้อย 8 ตัวอักษร';
  if (newPassword !== confirmPassword) return 'รหัสผ่านใหม่ทั้งสองช่องไม่ตรงกัน';
  if (hasEmailPassword && currentPassword === newPassword) return 'รหัสผ่านใหม่ต้องไม่ซ้ำกับรหัสผ่านปัจจุบัน';
  return '';
};

export const validatePasswordVerificationCode = (code: string) => /^\d{8}$/.test(code)
  ? ''
  : 'กรุณากรอกรหัสยืนยัน 8 หลักจากอีเมล';

